const styles = {
    iconMain: {
        color: "#f8f9fa",
        fontSize: "38px",
        padding: "12px 0px",
        borderRadius: 0,
        marginLeft: "6px"
    },
};
export default styles;